'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import l from "../defs/Code.es.js";
const e = a.forwardRef((r, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...r, weights: l }));
e.displayName = "CodeIcon";
const n = e;
export {
  n as Code,
  e as CodeIcon
};
